import React, {Fragment} from "react";
import {Card, CardBody, CardGroup, Modal, ModalBody} from "reactstrap";
import {withRouter} from "react-router-dom";
import SFXButtonComponent from "./SFXButtonComponent";
import ModalHeader from "react-bootstrap/ModalHeader";
import CardDataComponent from "./CardDataComponent";
import {ModalFooter} from "react-bootstrap";
import QuotationComponent from "./QuotationComponent";
import Beneficiary from "../domain/Beneficiary";
import BeneficiaryService from "../services/BeneficiaryService";
import TransactionRequiredFieldsComponent from "./TransactionRequiredFieldsComponent";
import SFXLoadingComponent from "./SFXLoadingComponent";
import ToastHelper from "../utils/ToastHelper";
import CreateObjectRowWithLabelComponent from "./CreateObjectRowWithLabelComponent";
import BeneficiaryRequiredFieldsService from "../services/BeneficiaryRequiredFieldsService";

const QUOTATION_REQUEST = "quotation request";
const BENEFICIARY_DETAILS = "beneficiary details";

const BENEFICIARY_CONFIG = [
    {
        dataField: "countryName",
        label: "Country"
    },
    {
        dataField: "payoutMethodName",
        label: "Payout Method"
    },
    {
        dataField: "payoutPartnerName",
        label: "Payout Partner"
    },
    {
        dataField: "currencyName",
        label: "Currency"
    },
    {
        dataField: "quotationType",
        label: "Quotation Type"
    },
    {
        dataField: "amount",
        label: "Amount"
    }
];

class BeneficiaryCardDataComponent extends React.Component {

    constructor(props) {
        super(props)

        this.baseUrl = this.props.baseUrl;

        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            beneficiaryList: [],
            beneficiaryBeingViewed: {},
            isModalShowing: false,
            isCreateBeneficiaryModalShowing: false,
            isDeleteBeneficiaryModalShowing: false,
            requiredFieldsValid: false,
            requiredFields: [],
            currentTab: QUOTATION_REQUEST,
            isLoading: true
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.props.history.replace(this.baseUrl);
        BeneficiaryService.retrieveBeneficiariesByRegistrationId(this.props.customer.registrationId, "", 10).then(response => {
            if (response["error-code"]) {
                ToastHelper.formatError(response);
            } else {
                this.setState({
                    beneficiaryList: response.body,
                    isLoading: false
                });
            }
        });
    }

    retrieveQuotationResponse = (quotationRequest, quotationResponse) => {
        this.setState({
            quotationRequest: quotationRequest,
            quotationResponse: quotationResponse
        }, () => this.setState({
            currentTab: BENEFICIARY_DETAILS
        }))
    };

    showModal(beneficiary) {
        BeneficiaryRequiredFieldsService.retrieveBeneficiaryRequiredFields(beneficiary.id).then(response => {
            if (response["errors"]) {
                ToastHelper.formatError(response)
            } else {

                this.setState({
                    isModalShowing: true,
                    requiredFields: response,
                    beneficiaryBeingViewed: beneficiary
                });
            }
        })
    }

    getRequiredFieldsForBeneficiary(beneficiary) {
        BeneficiaryRequiredFieldsService.retrieveBeneficiaryRequiredFields(beneficiary.id).then(response => {
            if (response["errors"]) {
                ToastHelper.formatError(response)
            } else {
                this.props.sendMoneyClick(response, beneficiary)
            }
        })
    }

    closedModal() {
        this.setState({
            isModalShowing: false,
            beneficiaryBeingViewed: {}
        });
    }

    showCreateBeneficiaryModal() {
        this.props.history.replace(this.baseUrl + "/new-beneficiary");
        this.setState({
            isCreateBeneficiaryModalShowing: true
        })
    }

    closeCreateBeneficiaryModal() {
        if (this.state.currentTab === QUOTATION_REQUEST) {
            this.props.history.replace(this.baseUrl)
            this.setState({
                isCreateBeneficiaryModalShowing: false,
                requiredFieldsValid: false
            });
        } else {
            this.setState({
                currentTab: QUOTATION_REQUEST,
                requiredFieldsValid: false
            });
        }
    }

    showDeleteBeneficiaryModal() {
        this.setState({
            isDeleteBeneficiaryModalShowing: true
        });
    }

    closeDeleteBeneficiaryModal() {
        this.setState({
            isDeleteBeneficiaryModalShowing: false
        });
    }

    showEditBeneficiaryModal() {
        this.setState({
            isEditBeneficiaryModalShowing: true
        });
    }

    closeEditBeneficiaryModal() {
        this.setState({
            isEditBeneficiaryModalShowing: false
        });
    }

    generateBeneficiaryCreationRequest() {

        let capturedValues = this.registerRef.getValues();

        let beneficiaryName = Beneficiary.generateBeneficiaryName(capturedValues["captured-fields"]);

        let beneficiaryCreationRequest = {};
        beneficiaryCreationRequest["id"] = 0;
        beneficiaryCreationRequest["registration-id"] = this.props.customer.registrationId;
        beneficiaryCreationRequest["beneficiary-name"] = beneficiaryName;
        beneficiaryCreationRequest["country-id"] = this.state.quotationRequest.countryId;
        beneficiaryCreationRequest["payout-method-id"] = this.state.quotationRequest.payoutMethodId;
        beneficiaryCreationRequest["payout-partner-id"] = this.state.quotationRequest.payoutPartnerId;
        beneficiaryCreationRequest["currency-id"] = this.state.quotationRequest.currencyId;
        beneficiaryCreationRequest["quotation-type"] = this.state.quotationRequest.quotationType;
        beneficiaryCreationRequest["amount"] = this.state.quotationRequest.amount;
        beneficiaryCreationRequest["quotation-reference"] = this.state.quotationResponse.quotationReference;
        beneficiaryCreationRequest["required-fields"] = capturedValues["captured-fields"];

        this.setState({
            isLoading: true,
            beneficiaryCreationRequest: beneficiaryCreationRequest
        }, () => this.createBeneficiary(beneficiaryCreationRequest))
    }

    createBeneficiary(beneficiaryCreationRequest) {

        BeneficiaryService.createBeneficiaryWithRequiredFields(beneficiaryCreationRequest).then(response => {
            if (response["error-code"]) {
                ToastHelper.formatError(response);
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    beneficiaryCreationErrors: response
                })
            } else {
                ToastHelper.success("Beneficiary successfully created")
                this.setState({
                    isLoading: false,
                    beneficiaryBeingViewed: {},
                    isModalShowing: false,
                    isCreateBeneficiaryModalShowing: false
                }, () => this.loadData());
            }
        })
    }

    deleteBeneficiary(beneficiary) {
        BeneficiaryService.deleteBeneficiary(beneficiary.id).then(response => {
            if (response === "success") {
                ToastHelper.success("Beneficiary successfully deleted");
                this.setState({
                    isDeleteBeneficiaryModalShowing: false,
                    isModalShowing: false,
                    isLoading: true
                }, () => this.loadData());
            } else {
                ToastHelper.formatError(response);
            }
        })
    }

    requiredFieldsValid = isValid => {
        this.setState({
            requiredFieldsValid: isValid
        })
    };

    render() {
        return <Fragment>
            {this.state.isLoading ? <SFXLoadingComponent/> : <Fragment>
                {
                    this.state.beneficiaryList.map((beneficiary, index) => {
                        return <CardGroup key={index}>
                            <Card>
                                <CardBody>
                                    <div style={{display: "flex", flex: 7}}>
                                        <h6 style={{
                                            flex: "5",
                                            fontWeight: "bold",
                                            fontSize: "20px",
                                            margin: "auto"
                                        }}
                                        >
                                            {beneficiary.beneficiaryName}
                                        </h6>
                                    </div>
                                    <br/>
                                    <div style={{display: "flex"}}>
                                        <div style={{flex: "5"}}>
                                            <CreateObjectRowWithLabelComponent label={"Country"}
                                                                               className={"pull-left"}>
                                                {beneficiary.countryName}
                                            </CreateObjectRowWithLabelComponent>
                                        </div>
                                        <div style={{flex: "5", textAlign: "right"}}>
                                            <CreateObjectRowWithLabelComponent label={"Payout Method"}
                                                                               className={"pull-left"}>
                                                {beneficiary.payoutMethodName}
                                            </CreateObjectRowWithLabelComponent>
                                        </div>
                                    </div>
                                    <div style={{display: "flex"}}>
                                        <div style={{flex: "5"}}>
                                            <CreateObjectRowWithLabelComponent label={"Payout Partner"}
                                                                               className={"pull-left"}>
                                                {beneficiary.payoutPartnerName}
                                            </CreateObjectRowWithLabelComponent>
                                        </div>
                                        <div style={{flex: "5", textAlign: "right"}}>
                                            <CreateObjectRowWithLabelComponent label={"Amount"} className={"pull-left"}>
                                                {beneficiary.amount}
                                            </CreateObjectRowWithLabelComponent>
                                        </div>
                                    </div>
                                    <hr/>
                                    <SFXButtonComponent color={"primary"} onClick={() => this.showModal(beneficiary)}>
                                        Details
                                    </SFXButtonComponent>
                                    {'  '}
                                    {(this.props.agentCanCreateTransactions && this.props.canTransactForCustomer) &&
                                    <SFXButtonComponent style={{float: "right"}} color={"primary"}
                                                        onClick={() => this.getRequiredFieldsForBeneficiary(beneficiary)}>
                                        Send Money Now
                                    </SFXButtonComponent>
                                    }
                                </CardBody>
                            </Card>
                        </CardGroup>
                    })
                }
                {this.state.isCreateBeneficiaryModalShowing && this.renderCreateBeneficiaryModal()}
                {this.state.isModalShowing && this.renderModalForBeneficiary()}
                {/*{this.state.isDeleteBeneficiaryModalShowing && this.renderDeleteBeneficiaryModal()}*/}
                {/*{this.state.isEditBeneficiaryModalShowing && this.renderEditBeneficiaryModal()}*/}
            </Fragment>}
        </Fragment>
    }

    renderContent(className) {
        return <Fragment>
            {this.state.isLoading ? <SFXLoadingComponent/> :
                <Fragment>
                    {this.state.currentTab === QUOTATION_REQUEST && this.renderQuotation(className)}
                    {this.state.currentTab === BENEFICIARY_DETAILS && this.renderRequiredFields(className)}
                </Fragment>
            }
        </Fragment>
    }

    renderModalForBeneficiary() {
        let beneficiary = this.state.beneficiaryBeingViewed;

        return <Modal isOpen={this.state.isModalShowing}>
            <ModalHeader style={{display: "flex"}}>
                <h6 style={{
                    flex: "5",
                    fontWeight: "bold",
                    fontSize: "20px",
                    margin: "auto"
                }}>{beneficiary.beneficiaryName}</h6>
            </ModalHeader>
            <ModalBody>
                <CardDataComponent
                    data={beneficiary}
                    config={BENEFICIARY_CONFIG}
                />
                {this.state.requiredFields.map((value, index) => {
                    return <Fragment key={index}>
                        <h6>{value.displayName}</h6>
                        <h6 style={{color: "grey"}}>{value.value}</h6>
                    </Fragment>
                })}
                <hr/>
                <SFXButtonComponent onClick={this.closedModal.bind(this)} className={"btn-secondary"}>
                    Back
                </SFXButtonComponent>
            </ModalBody>
        </Modal>
    }

    renderCreateBeneficiaryModal() {
        return <Modal isOpen={this.state.isCreateBeneficiaryModalShowing}>
            <ModalHeader style={{display: "flex"}}>
                <h6 style={{
                    flex: "5",
                    fontWeight: "bold",
                    fontSize: "20px",
                    margin: "auto"
                }}>{"New Beneficiary"}</h6>
            </ModalHeader>
            <ModalBody>
                {this.renderContent("mobile")}
            </ModalBody>
            {!this.state.isLoading &&
            <ModalFooter>
                <SFXButtonComponent onClick={this.generateBeneficiaryCreationRequest.bind(this)}
                                    className={"btn-primary"} hidden={!this.state.requiredFieldsValid}>
                    Create
                </SFXButtonComponent>
                {'   '}
                <SFXButtonComponent onClick={this.closeCreateBeneficiaryModal.bind(this)} className={"btn-secondary"}>
                    Back
                </SFXButtonComponent>
            </ModalFooter>
            }
        </Modal>
    }

    renderRequiredFields(className) {

        return <Fragment>
            <TransactionRequiredFieldsComponent
                className={className}
                registerRef={ref => this.registerRef = ref}
                requiredFields={this.state.quotationResponse.requiredFields}
                isValid={this.requiredFieldsValid}
                saveBeneficiary={false}
            />
        </Fragment>
    }

    renderQuotation(className) {

        return <Fragment>

            <QuotationComponent
                className={className}
                returnQuotationResponse={this.retrieveQuotationResponse}
            />

        </Fragment>
    }
}

export default withRouter(BeneficiaryCardDataComponent);